import {React, useEffect, useState, useRef} from 'react';
import '../App.css';
import './reviews.css';
import { Helmet } from "react-helmet";
import { useScrollBehavior } from './useScrollBehavior.js';
import Image1 from '../images/image4.webp';
import Image9 from '../images/image7.webp';
import Image10 from '../images/image5.webp';
import Image12 from '../images/image6.webp';
//import Image44 from '../images/image44.jpg';
//import Image45 from '../images/image45.jpg';
//import Image48 from '../images/image48.jpg';
//import Image52 from '../images/image52.jpg';
import Image88 from '../images/image88.webp';
import Image89 from '../images/image89.webp';
import Image90 from '../images/image90.webp';
import Image91 from '../images/image91.webp';
import Image92 from '../images/image92.webp';
//import Image93 from '../images/image93.jpg';
import Image94 from '../images/image94.webp';
import Image99 from '../images/image99.webp';
//import Image100 from '../images/image100.jpg';
import Image101 from '../images/image101.webp';
import Image102 from '../images/image102.webp';
import Image107 from '../images/image107.webp';
import Image110 from '../images/image110.webp';
//import Image111 from '../images/image111.jpg';
//import Image112 from '../images/image112.jpg';
import ExpandedImage from './ExpandedImage.js';
import Footer from './footer4.js'

const Reviews = () => {

	useScrollBehavior();

	const [isVisibleImage5, setIsVisibleImage5] = useState(false);
	const [expandedImage5, setExpandedImage5] = useState(null);
	const imageRef5 = useRef(null);

	const handleScroll6 = () => {

		  if (imageRef5.current) {
			const imageRect5 = imageRef5.current.getBoundingClientRect();
			const triggerOffsetImage5 = 130; // Adjust this value for different trigger points
			const triggerPointImage5 = window.innerHeight - triggerOffsetImage5;
			const isAboveTriggerPointImage5 = imageRect5.top < triggerPointImage5;
			setIsVisibleImage5(isAboveTriggerPointImage5);
		  }
	  };

	  useEffect(() => {
		window.addEventListener('scroll', handleScroll6);
		handleScroll6(); // Check visibility on initial render
		return () => {
		  window.removeEventListener('scroll', handleScroll6);
		};
		}, []);

		useEffect(() => {
						  const hash = window.location.hash.substring(1);
						  if (hash) {
							const targetElement = document.getElementById(hash);
							if (targetElement) {
								targetElement.scrollIntoView({ behavior: 'smooth' });
							}
						  }
					  }, []);
	

	const images = [
		{ id: 1, url: Image1, alt: 'Image 1'},
	  	{ id: 2, url: Image10, alt: 'Image 2'},
	  	{ id: 3, url: Image12, alt: 'Image 3'},
	  	{ id: 4, url: Image9, alt: 'Image 4'},
	  	{ id: 5, url: Image88, alt: 'Image 5'},
	  	{ id: 6, url: Image89, alt: 'Image 6' },
	  	{ id: 7, url: Image90, alt: 'Image 7' },
	  	{ id: 8, url: Image91, alt: 'Image 8' },
		{ id: 9, url: Image92, alt: 'Image 9'},
	  	{ id: 10, url: Image99, alt: 'Image 10'},
	  	{ id: 11, url: Image94, alt: 'Image 11'},
	  	{ id: 12, url: Image101, alt: 'Image 12'},
	  	{ id: 13, url: Image102, alt: 'Image 13'},
	  	{ id: 14, url: Image107, alt: 'Image 14' },
	  	{ id: 15, url: Image110, alt: 'Image 15' },
	  ];

	  const prepareImagesWithOrder = (images) => {
		return images.map((image, index) => ({
		  ...image,
		  relatedImages: [
			image.url,
			...images
			  .slice(index + 1)
			  .concat(images.slice(0, index))
			  .map((img) => img.url),
		  ],
		}));
	  };

	  const updatedImages = prepareImagesWithOrder(images);

	  
	  

	  const handleGridItemClick5 = (image) => {
		const selectedImage = updatedImages.find((img) => img.id === image.id);
  		setExpandedImage5(selectedImage);
		//setExpandedImage5(image);
		//document.querySelector('.modal-overlay').classList.add('show');
		//document.querySelector('.modal-container').classList.add('show');
		//const imageRect = document.querySelector(`[src="${image.url}"]`).getBoundingClientRect();
		const modalContainer = document.querySelector('.modal-container2');
		modalContainer.style.top = '50%'; /* keep the top position as 50% */
		modalContainer.style.left = '50%'; /* keep the left position as 50% */
		modalContainer.style.transform = 'translate(-50%, -50%)'; /* keep the transform as translate(-50%, -50%) */
		modalContainer.style.width = '90%'; /* keep the width as 90% */
		modalContainer.style.height = '100vh'; /* keep the height as 100vh */
		document.querySelector('.modal-overlay2').classList.add('show');
		modalContainer.classList.add('show');
		};

		const handleCloseExpandedImage5 = () => {
		setExpandedImage5(null);
		document.querySelector('.modal-overlay2').classList.remove('show');
		document.querySelector('.modal-container2').classList.remove('show');
		};



	return (
		<>
		<Helmet>
  			<title>Customer Reviews | Sam's Tree Service</title>
  			<meta name="description" content="Read real customer reviews for Sam's Tree Service. See how we've helped Sarasota homeowners with expert tree care, from removal to trimming." />
			<link rel="canonical" href="https://samstreeservice.com/reviews" />
		</Helmet>

		<div id='main_reviewtDiv'>
			<div className="background-imagereview"></div>
			<div className="module_review" id="module_review1">
				<div id='review_div1'>
					<div id='cover_review_div1'>
						<div id='review_title'>
						<h1>Real Feedback, Real Results</h1>
						</div>
						
					</div>
				</div>	
            </div>
			<div className="module_review" id="module_review2">
				<div id='review_div3'>
					<div id="collect-grid-container3" ref={imageRef5}>
						{images.map((image) => (
					<div  id={`image-${image.id}`} className={`collect-grid-item3 ${isVisibleImage5  ? 'visible' : ''}`} key={image.id}  style={{ transitionDelay: '.3s' }} onClick={() => handleGridItemClick5(image)}>
					 	<img src={image.url} alt={image.alt} />
					</div>
						))}
					</div>
					<div className="modal-overlay2"></div>
					<div className="modal-container2">
							{expandedImage5 && (
								<ExpandedImage imageUrl={expandedImage5.url} relatedImages={expandedImage5.relatedImages} onClose={handleCloseExpandedImage5} />
							)}
					</div>
						
						

				</div>
				<div id="reviews_button"
  						onClick={() => {
   							 window.location.href = "https://www.google.com/search?client=firefox-b-1-d&sca_esv=71ecfd477e9beca5&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzfGevUkDKogCpeEx_4Gv0cIZfTHmOI9e08zDG8ULg2eYmbl9Nw5jvWBMMJh68f61K7B2r4CaahtTXGtei1U8qkBT7S5if8ng13fGj40YuGDkIumRNw%3D%3D&q=SAM%E2%80%99S+Tree+Service+Reviews&sa=X&ved=2ahUKEwi_gpPOt7yMAxWxSDABHQOMJKEQ0bkNegQIJxAD&biw=1902&bih=851&dpr=1";
  							}}
							>
  							Read More Reviews
				</div>
						
		 		</div>
			<Footer/>	
		</div>
	</>
	);
};

export default Reviews;
